var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import { getFelicaBrandDisplayName } from '@square/dashboard-data/utils/felica-brand';
import { getDisplayName as getCardBrandDisplayName } from '@square/dashboard-data/utils/card-brand';
import { camelize } from '@ember/string';
let TenderHelper = (_class = class TenderHelper extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
  }
  felicaBrandName(felicaBrand) {
    return getFelicaBrandDisplayName(felicaBrand, this.intl);
  }
  otherTenderName(otherTenderType) {
    if (otherTenderType) {
      const key = camelize(otherTenderType.toLowerCase());
      // eslint-disable-next-line square/no-translation-key-interpolation
      return this.intl.t(`common.otherTenderTypes.${key}`);
    }
    return undefined;
  }
  externalTenderName(externalTender) {
    if (externalTender) {
      const applicationName = externalTender.get('paymentSource.applicationName');
      return this.intl.t('activity.transactions.details.external', {
        applicationName
      });
    }
    return undefined;
  }
  displayName(model) {
    if (model.hasCardDetails) {
      return this.intl.t('activity.transactions.details.endingIn', {
        brandName: model.isEMoney ? this.felicaBrandName(model.felicaBrand) : this.cardBrandName(model.cardBrand),
        suffix: model.panSuffix
      });
    } else if (model.isCash) {
      return this.intl.t('activity.transactions.details.cash');
    } else if (model.isTab) {
      return this.intl.t('activity.transactions.details.wallet');
    } else if (model.isOther) {
      return this.otherTenderName(model.otherTenderType);
    } else if (model.isExternal) {
      return this.externalTenderName(model.externalTender);
    } else if (model.isBankTransfer) {
      return this.intl.t('activity.transactions.details.bankTransfer');
    }
    return undefined;
  }
  cardBrandName(cardBrand) {
    return getCardBrandDisplayName(cardBrand, this.intl);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { TenderHelper as default };